module.exports = __webpack_public_path__ + "img/banner.995c6eda.png";